import type { ModalFiltersConfigSection } from '../types/filter-config-section';
import type { FilterStates } from '../view-models/filter-states';

/**
 * Generate the modal filter config for the facet filters.
 * @param states The filter states.
 * @returns The modal filter config for the facet filters.
 */
export function getFacetFilterConfig(
    states: FilterStates,
): ModalFiltersConfigSection[] {
    if (!states.facet?.facetOptions?.length) {
        return [];
    }
    return states.facet.facetOptions.map((facetState) => {
        return {
            title: facetState.name,
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'multiple',
                    columns: 1,
                    filterKey: facetState.id,
                },
            ],
        };
    });
}
